require('./cmWalletBuyStep3.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const classNames = require('classnames');

// @ components
const {
    GDPRSignaturePattern,
} = require('components/gdprSignaturePattern/gdprSignaturePattern');
const {
    OKConsents,
} = require('gdpr-consents/components/OKConsents/OKConsents.js');
const CmValidationSummary = require('../../cmValidationSummary/cmValidationSummary');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @helpers
const { toFirstUppercase } = require('utilities/stringHelper');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM,
} = require('constants/index');

const {
    BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
    BROKER_INTERNAL_TRANSFER_FUND_ID,
    BROKER_HIRE_INVESTMENT_FUND_ID,
} = require('constants/operationTypes');
const {
    CM_OPERATION_ID,
    CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE,
    CM_GDPR_PID,
    CM_BUY_TYPE_MONEY,
    CM_WIZARD_FIRST_STEP,
    CM_WIZARD_SECOND_STEP,
    CM_WIZARD_THIRD_STEP,
    CM_OPERATION_TYPE_TRASPASS,
    CM_EUR_CURRENCY,
} = require('../../../constants/constants');

class cmWalletBuyStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDisclaimerChange = this.handleDisclaimerChange.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.getNextButton = this.getNextButton.bind(this);
        this.handleOnConfirmLeave = this.handleOnConfirmLeave.bind(this);
        this.skipLeaveTransferMoney = this.skipLeaveTransferMoney.bind(this);
    }

    componentWillMount() {
        this.props.resetConsents();
    }

    componentWillUnmount() {
        const { actions } = this.props;
        actions.resetStep(2);
    }

    handleDisclaimerChange(ev) {
        this.props.changeDisclaimerCheck(ev.target.checked);
    }

    handleNextClick() {
        this.props.runTransferLiquidityOrchestrator();
    }

    handlePrevClick() {
        const { actions, visibleStep } = this.props;

        actions.setVisibleStep(visibleStep - 1);
        if (actions.resetStep) {
            //reset leaving step
            actions.resetStep(visibleStep);
        }
    }

    handleOnConfirmLeave() {
        this.props.onConfirmLeaveTransferMoneyToOtherPage();
    }

    skipLeaveTransferMoney() {
        const { immCmWalletBuy } = this.props;

        return immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'skipLeaveTransferMoney',
        ]);
    }

    buildHeader(liquidityTransfer) {
        let headerTitle;
        if (liquidityTransfer) {
            headerTitle = (
                <FormattedText value="brokerCM-brokerCM_walletBuyStep3FromMoneyTitle" />
            );
        } else {
            headerTitle = (
                <FormattedText value="brokerCM-walletBuyStep3Title" />
            );
        }
        return (
            <div className="cm-wallet-buy-step3__header">
                <h2 className="cm-wallet-buy-step3__title">{headerTitle}</h2>
            </div>
        );
    }

    buildHeaderTransferWithMoney() {
        const { immCmWalletBuy } = this.props;
        const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);
        const className = classNames({
            '--disabled-header': !confirmFundsFromFundsWithMoney,
        });

        return (
            <div className={`cm-wallet-buy-step3__header${className}`}>
                <h2 className="cm-wallet-buy-step3__title">
                    <FormattedText value="brokerCM-brokerCM_walletBuyStep3TransferWithMoneyTitle" />
                </h2>
            </div>
        );
    }

    buildSignaturePattern() {
        const { immCmWalletBuy } = this.props;
        const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const originFundInfo = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'originFundInfo',
        ]);
        const originFund = originFundInfo.get('infoFondosPosicionGlobal');

        let operationParams, operationType, message;

        if (isTransferWithMoney && confirmFundsFromFundsWithMoney) {
            return null;
        }

        if (isTransferWithMoney) {
            message = (
                <div className="cm-wallet-buy-step2__funds-to-buy-leyend">
                    <OKMessage type="informative">
                        <FormattedText value="brokerCM-brokerCM_buyStep3FirstConfirmationMessage" />
                    </OKMessage>
                </div>
            );
        }

        if (
            immCmWalletBuy
                .get('orderValidation')
                .get('portfolioOrderValidTransferOk')
                .count() > 1
        ) {
            const requestMulti = immCmWalletBuy
                .get('orderValidation')
                .get('portfolioOrderValidTransferOk')
                .map(() => {
                    const contractIdProduct = originFund.getIn([
                        'contrato',
                        'producto',
                    ]);
                    const contractIdNumber = originFund.getIn([
                        'contrato',
                        'numeroContrato',
                    ]);
                    return {
                        originAccount:
                            API_ENTERPRISE_NUMBER +
                            API_CENTER +
                            contractIdProduct +
                            contractIdNumber,
                        serviceCode: BROKER_INTERNAL_TRANSFER_FUND_ID,
                    };
                });
            operationParams = requestMulti.toJS();
            operationType = CM_OPERATION_ID;
        } else if (
            immCmWalletBuy
                .get('orderValidation')
                .get('portfolioOrderValidTransferOk')
                .count() > 0
        ) {
            const orderFundProduct = originFund.getIn(['contrato', 'producto']);
            const orderFundContract = originFund.getIn([
                'contrato',
                'numeroContrato',
            ]);

            operationParams = {
                originAccount: `${BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM}${orderFundProduct}${orderFundContract}`,
                serviceCode: BROKER_INTERNAL_TRANSFER_FUND_ID,
            };

            operationType = BROKER_INTERNAL_TRANSFER_FUND_ID;
        }

        return (
            <div>
                <ContentBox hasShadow={false}>
                    <OKConsents placementId={CM_GDPR_PID} />
                    <GDPRSignaturePattern
                        operationType={operationType}
                        operationParams={operationParams}
                        isWealth={true}
                    />
                </ContentBox>
                {message}
            </div>
        );
    }

    buildSignaturePatternFromMoney() {
        const { immCmWalletBuy } = this.props;
        let operationParams, operationType;
        if (
            immCmWalletBuy
                .get('orderValidation')
                .get('validOrderResultOutputOk')
                .count() > 1
        ) {
            const requestMulti = immCmWalletBuy
                .get('orderValidation')
                .get('validOrderResultOutputOk')
                .map(fund => {
                    const contractIdProduct = fund.getIn([
                        'contratoFondo',
                        'fundContractIdProduct',
                    ]);
                    const contractIdNumber = fund.getIn([
                        'contratoFondo',
                        'fundContractIdNumber',
                    ]);
                    const isSubscription =
                        fund.get('operationType') ===
                        CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE;
                    if (isSubscription) {
                        const currencyObject = {
                            amount: fund.get('subAssetClassFundAmount'),
                            currency: fund.get('codMomCuenta'),
                        };

                        return {
                            originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${contractIdProduct}${contractIdNumber}`,
                            ammount: parseFloat(currencyObject.amount),
                            currency: CM_EUR_CURRENCY,
                            serviceCode: BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
                        };
                    } else {
                        return {
                            originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${contractIdProduct}${contractIdNumber}`,
                            serviceCode: BROKER_HIRE_INVESTMENT_FUND_ID,
                        };
                    }
                });
            operationParams = requestMulti.toJS();
            operationType = CM_OPERATION_ID;
        } else if (
            immCmWalletBuy
                .get('orderValidation')
                .get('validOrderResultOutputOk')
                .count() > 0
        ) {
            const orderFundInfo = immCmWalletBuy
                .get('orderValidation')
                .get('validOrderResultOutputOk')
                .first();
            const orderFundProduct = orderFundInfo.getIn([
                'contratoFondo',
                'fundContractIdProduct',
            ]);
            const orderFundContract = orderFundInfo.getIn([
                'contratoFondo',
                'fundContractIdNumber',
            ]);
            const isSubscription =
                orderFundInfo.get('operationType') ===
                CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE;

            if (isSubscription) {
                const currencyObject = {
                    amount: orderFundInfo.get('subAssetClassFundAmount'),
                    currency: orderFundInfo.get('codMomCuenta'),
                };

                operationParams = {
                    originAccount: `${BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM}${orderFundProduct}${orderFundContract}`,
                    ammount: parseFloat(currencyObject.amount),
                    currency: CM_EUR_CURRENCY,
                    serviceCode: BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
                };
            } else {
                operationParams = {
                    originAccount: `${BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM}${orderFundProduct}${orderFundContract}`,
                };
            }

            operationType = isSubscription
                ? BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID
                : BROKER_HIRE_INVESTMENT_FUND_ID;
        }

        return (
            <ContentBox hasShadow={false}>
                <OKConsents placementId={CM_GDPR_PID} />
                <GDPRSignaturePattern
                    operationType={operationType}
                    operationParams={operationParams}
                    isWealth={true}
                />
            </ContentBox>
        );
    }

    buildSignaturePatternFromTransferMoney() {
        const { immCmWalletBuy } = this.props;
        const validOrderResultOutputOk = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyData',
            'portfolioOrderValidationOutput',
            'validOrderResultOutputOk',
        ]);
        let operationParams, operationType;

        if (validOrderResultOutputOk.count() > 1) {
            const requestMulti = validOrderResultOutputOk.map(fund => {
                const contractIdProduct = fund.getIn([
                    'contratoFondo',
                    'fundContractIdProduct',
                ]);
                const contractIdNumber = fund.getIn([
                    'contratoFondo',
                    'fundContractIdNumber',
                ]);
                const isSubscription =
                    fund.get('operationType') ===
                    CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE;
                if (isSubscription) {
                    const currencyObject = {
                        amount: fund.get('subAssetClassFundAmount'),
                        currency: fund.get('moneda'),
                    };

                    return {
                        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${contractIdProduct}${contractIdNumber}`,
                        ammount: parseFloat(currencyObject.amount),
                        currency: CM_EUR_CURRENCY,
                        serviceCode: BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
                    };
                } else {
                    return {
                        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${contractIdProduct}${contractIdNumber}`,
                        serviceCode: BROKER_HIRE_INVESTMENT_FUND_ID,
                    };
                }
            });
            operationParams = requestMulti.toJS();
            operationType = CM_OPERATION_ID;
        } else if (validOrderResultOutputOk.count() > 0) {
            const orderFundInfo = validOrderResultOutputOk.first();
            const orderFundProduct = orderFundInfo.getIn([
                'contratoFondo',
                'fundContractIdProduct',
            ]);
            const orderFundContract = orderFundInfo.getIn([
                'contratoFondo',
                'fundContractIdNumber',
            ]);
            const isSubscription =
                orderFundInfo.get('operationType') ===
                CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE;

            if (isSubscription) {
                const currencyObject = {
                    amount: orderFundInfo.get('subAssetClassFundAmount'),
                    currency: orderFundInfo.get('codMomCuenta'),
                };

                operationParams = {
                    originAccount: `${BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM}${orderFundProduct}${orderFundContract}`,
                    ammount: parseFloat(currencyObject.amount),
                    currency: CM_EUR_CURRENCY,
                    serviceCode: BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
                };
            } else {
                operationParams = {
                    originAccount: `${BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM}${orderFundProduct}${orderFundContract}`,
                };
            }

            operationType = isSubscription
                ? BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID
                : BROKER_HIRE_INVESTMENT_FUND_ID;
        }

        return (
            <ContentBox hasShadow={false}>
                <OKConsents placementId={CM_GDPR_PID} />
                <GDPRSignaturePattern
                    operationType={operationType}
                    operationParams={operationParams}
                    isWealth={true}
                />
            </ContentBox>
        );
    }

    buildEmptyOrderValidation() {
        const primaryText = (
            <div className="cm-model-wallet-error__empty-state-text">
                <div>
                    {formatText('brokerCM-brokerCM_validationOrderError')}
                </div>
                <div>
                    {formatText(
                        'brokerCM-brokerCM_validationOrderErrorSecondText',
                    )}
                </div>
            </div>
        );

        return (
            <ContentBox hasShadow={false}>
                <EmptyState
                    secondaryText={primaryText}
                    iconType="noitems-wealth"
                    withMargin={false}
                />
            </ContentBox>
        );
    }

    buildFundsSummary(portfolio, secondTable) {
        const { immCmWalletBuy } = this.props;
        const portfolioOrderValidationOutputEmpty = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'portfolioOrderValidationOutputEmpty',
        ]);

        if (secondTable && portfolioOrderValidationOutputEmpty) {
            return this.buildEmptyOrderValidation();
        } else {
            const isTransferWithMoney = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_FIRST_STEP,
                'isTransferWithMoney',
            ]);
            const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_THIRD_STEP,
                'confirmFundsFromFundsWithMoney',
            ]);

            return (
                <CmValidationSummary
                    portfolio={portfolio}
                    onLegalDocumentClick={this.props.onLegalDocumentClick}
                    isFromCalculator={
                        !confirmFundsFromFundsWithMoney && isTransferWithMoney
                    }
                    hideDocument={true}
                />
            );
        }
    }

    getPreviousButton() {
        const { immCmWalletBuy } = this.props;
        const buttonText = toFirstUppercase(
            formatText('buttonsActions-previous'),
        );
        const nextButtonDisabled = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);

        return (
            <div className="cm-wallet-buy-step3__second-button">
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-anterior"
                    onClick={this.handlePrevClick}
                    disabled={nextButtonDisabled}
                >
                    {buttonText}
                </OKButton>
            </div>
        );
    }

    getNextButton() {
        const { immCmWalletBuy } = this.props;
        const buttonText = toFirstUppercase(
            formatText('brokerCM-brokerCM_step3ConfirmButton'),
        );
        const nextButtonDisabled = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);
        const isLoading = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'isLoading',
        ]);

        if (nextButtonDisabled) {
            return (
                <div className="cm-wallet-buy-step3__third-button">
                    <OKButton modifier="primary" disabled={true}>
                        {buttonText}
                    </OKButton>
                </div>
            );
        } else {
            return (
                <div className="cm-wallet-buy-step3__third-button">
                    <SignaturePatternButton
                        modifier="primary"
                        onClick={this.handleNextClick}
                        loading={isLoading}
                    >
                        {buttonText}
                    </SignaturePatternButton>
                </div>
            );
        }
    }

    buildTransferWithMoney() {
        const { immCmWalletBuy } = this.props;
        const headerBlock = this.buildHeaderTransferWithMoney();
        const validatedOriginFundInfo = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_SECOND_STEP,
            'originFund',
        ]);
        const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);
        const portfolioOrderValidationOutputEmpty = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'portfolioOrderValidationOutputEmpty',
        ]);
        const nextButton = this.getNextButton();
        const previousButton = this.getPreviousButton();
        const className = classNames({
            'cm-wallet-buy-step3__summary--disabled': !confirmFundsFromFundsWithMoney,
            'cm-wallet-buy-step3__summary--empty':
                confirmFundsFromFundsWithMoney &&
                portfolioOrderValidationOutputEmpty,
        });

        let portfolio;
        let signaturePattern;

        if (!confirmFundsFromFundsWithMoney) {
            const destFundsTransferCalculatorOutputList = validatedOriginFundInfo.getIn(
                [
                    'destFundsTransferCalculatorOutput',
                    'destFundTransferCalculatorList',
                ],
            );
            portfolio = destFundsTransferCalculatorOutputList.filter(
                destFund =>
                    !destFund
                        .get('operationType')
                        .startsWith(CM_OPERATION_TYPE_TRASPASS),
            );
        } else {
            portfolio = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_THIRD_STEP,
                'confirmFundsFromFundsWithMoneyData',
                'portfolioOrderValidationOutput',
                'validOrderResultOutputOk',
            ]);
        }

        const secondTable = true;
        const fundsSummary = this.buildFundsSummary(portfolio, secondTable);

        if (
            confirmFundsFromFundsWithMoney &&
            !portfolioOrderValidationOutputEmpty
        ) {
            signaturePattern = this.buildSignaturePatternFromTransferMoney();
        }

        return (
            <div>
                <div className="cm-wallet-buy-step3__buttons">
                    {previousButton}
                    {nextButton}
                </div>
                <header className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12">
                        {headerBlock}
                    </div>
                </header>
                <ContentBox customClassName={className} hasShadow={false}>
                    {fundsSummary}
                </ContentBox>
                {signaturePattern}
            </div>
        );
    }

    render() {
        const { immCmWalletBuy } = this.props;
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const liquidityTransfer =
            immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const headerBlock = this.buildHeader(liquidityTransfer);
        const orderValidation = immCmWalletBuy.get('orderValidation');
        const successful = liquidityTransfer
            ? orderValidation.get('validOrderResultOutputOk')
            : immCmWalletBuy.getIn([
                  'orderValidation',
                  'portfolioOrderValidTransferOk',
              ]);
        const secondTable = false;
        const fundsSummary = this.buildFundsSummary(
            successful,
            liquidityTransfer,
            secondTable,
        );
        const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);
        const confirmFundsFromFundsWithMoneyLoading = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyLoading',
        ]);

        let signaturePattern;
        let isTransferWithMoneyBox;
        let preLeaveModalComponent;

        if (
            immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_THIRD_STEP,
                'resetConsents',
            ]) &&
            !confirmFundsFromFundsWithMoneyLoading
        ) {
            if (liquidityTransfer) {
                signaturePattern = this.buildSignaturePatternFromMoney();
            } else {
                signaturePattern = this.buildSignaturePattern();
            }
        }

        if (!liquidityTransfer && isTransferWithMoney) {
            isTransferWithMoneyBox = this.buildTransferWithMoney();
        }

        if (
            !liquidityTransfer &&
            isTransferWithMoney &&
            confirmFundsFromFundsWithMoney
        ) {
            const modalText = formatText(
                'brokerCM-brokerCM_LeaveTransferMoneySubHeader',
            );
            const modalTitle = formatText(
                'brokerCM-brokerCM_LeaveTransferMoneyHeader',
            );
            const continueText = formatText(
                'brokerCM-brokerCM_LeaveTransferMoneyContinueButton',
            );
            const leaveText = formatText(
                'brokerCM-brokerCM_LeaveTransferMoneyLeaveButton',
            );
            const highlightCTA = true;
            const leftButtonConfig = {
                text: leaveText,
                redirect: true,
            };

            const rightButtonConfig = {
                text: continueText,
                redirect: false,
            };

            preLeaveModalComponent = (
                <PreLeaveModalComponent
                    confirmationMessage={modalText}
                    confirmationTitle={modalTitle}
                    leftButtonConfig={leftButtonConfig}
                    rightButtonConfig={rightButtonConfig}
                    isReady={this.skipLeaveTransferMoney}
                    onConfirmLeave={this.handleOnConfirmLeave}
                    highlightCTA={highlightCTA}
                    className="cm-wallet-buy-step3__pre-leave-modal"
                />
            );
        }

        return (
            <div>
                <div className="cm-wallet-buy-step3">
                    <header className="row">
                        <div className="col-lg-12 col-md-12 col-xs-12">
                            {headerBlock}
                        </div>
                    </header>
                    <ContentBox hasShadow={false}>{fundsSummary}</ContentBox>
                    <div className="cm-wallet-buy-step3__gdpr-section">
                        {signaturePattern}
                        {isTransferWithMoneyBox}
                    </div>
                    {preLeaveModalComponent}
                </div>
            </div>
        );
    }
}

cmWalletBuyStep3.propTypes = {
    actions: PropTypes.object.isRequired,
    visibleStep: PropTypes.number.isRequired,
    immCmWalletBuy: PropTypes.object.isRequired,
    changeDisclaimerCheck: PropTypes.func.isRequired,
    onLegalDocumentClick: PropTypes.func,
    runTransferLiquidityOrchestrator: PropTypes.func,
    onConfirmLeaveTransferMoneyToOtherPage: PropTypes.func,
    resetConsents: PropTypes.func,
};

module.exports = cmWalletBuyStep3;
